/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Signed_Out_WhyInputs */

const th_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้านี้แสดงสิ่งที่เชื่อมโยงกับคุณ — บุตรหลานที่คุณดูแล ทีมที่คุณฝึกสอน และรายการแข่งขันที่คุณติดตาม เข้าสู่ระบบเพื่อดูข้อมูลเหล่านี้`)
};

const en_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page is built from what you are connected to — the children you are guardian to, the teams you coach, the events you follow. Signing in is what fills it.`)
};

const ja_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このページは、あなたとつながりのあるもの — 保護するお子さん、指導するチーム、フォローしている大会 — から作られます。サインインすると表示されます。`)
};

const zh_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个页面由与你相关的一切构成——你监护的孩子、你执教的球队、你关注的赛事。只有登录才能把它填满。`)
};

const es_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página se construye a partir de aquello con lo que estás conectado: los menores de los que eres tutor, los equipos que entrenas, los eventos que sigues. Iniciar sesión es lo que la llena.`)
};

const pt_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página é montada a partir daquilo a que você está ligado — as crianças de quem você é responsável, os times que treina, os eventos que segue. Entrar é o que a preenche.`)
};

const id_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini terbentuk dari apa yang terhubung dengan Anda — anak yang Anda wali, tim yang Anda latih, acara yang Anda ikuti. Masuk dulu untuk mengisinya.`)
};

const fr_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page se construit à partir de ce à quoi vous êtes lié — les enfants dont vous êtes tuteur, les équipes que vous entraînez, les événements que vous suivez. C’est la connexion qui la remplit.`)
};

const tl_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabubuo ang pahinang ito mula sa mga bagay na kaugnay mo — ang mga batang inaalagaan mo, ang mga team na kinoko-coach mo, ang mga event na sinusundan mo. Ang pag-sign in ang pumupuno nito.`)
};

const vi_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang này hình thành từ những gì gắn với bạn — những đứa trẻ bạn giám hộ, những đội bạn dẫn dắt, những sự kiện bạn theo dõi. Đăng nhập mới lấp đầy nó.`)
};

const ko_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 페이지는 회원님과 연결된 것들로 채워집니다 — 보호하는 아이들, 지도하는 팀, 팔로우하는 이벤트. 로그인해야 내용이 채워집니다.`)
};

const de_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite entsteht aus dem, womit du verbunden bist — den Kindern, für die du erziehungsberechtigt bist, den Teams, die du trainierst, den Events, denen du folgst. Erst die Anmeldung füllt sie.`)
};

const ru_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта страница складывается из того, с чем вы связаны, — детей, чьим опекуном вы являетесь, команд, которые тренируете, событий, на которые подписаны. Наполняет её только вход.`)
};

const tr_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sayfa sizinle bağlantılı olanlardan oluşur — velisi olduğunuz çocuklar, çalıştırdığınız takımlar, takip ettiğiniz etkinlikler. Ancak giriş yapınca dolar.`)
};

const it_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa pagina nasce da ciò a cui sei collegato: i ragazzi di cui sei tutore, le squadre che alleni, gli eventi che segui. Solo l'accesso la riempie.`)
};

const pl_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta strona powstaje z tego, z czym jesteś związany — dzieci, których jesteś opiekunem, drużyn, które prowadzisz, wydarzeń, które obserwujesz. Dopiero logowanie ją wypełnia.`)
};

const uk_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ця сторінка складається з того, з чим ви пов'язані, — дітей, чиїм опікуном ви є, команд, які тренуєте, подій, за якими стежите. Наповнює її лише вхід.`)
};

const hi_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह पृष्ठ उन्हीं चीज़ों से बनता है जिनसे आप जुड़े हैं — वे बच्चे जिनके आप अभिभावक हैं, वे टीमें जिन्हें आप प्रशिक्षित करते हैं, वे आयोजन जिन्हें आप फ़ॉलो करते हैं। साइन इन करने पर ही यह भरता है।`)
};

const ar_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتكوّن هذه الصفحة مما أنت مرتبط به — الأطفال الذين أنت وليّ أمرهم، والفرق التي تدرّبها، والفعاليات التي تتابعها. لا يملؤها إلا تسجيل الدخول.`)
};

const ms_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini terbentuk daripada apa yang berkaitan dengan anda — anak yang anda jaga, pasukan yang anda latih, acara yang anda ikuti. Hanya log masuk mengisinya.`)
};

const bn_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই পৃষ্ঠা গড়ে ওঠে আপনি যার সঙ্গে যুক্ত তা দিয়ে — যে শিশুদের আপনি অভিভাবক, যে দল আপনি প্রশিক্ষণ দেন, যে আয়োজন আপনি অনুসরণ করেন। সাইন ইন করলেই এটি ভরে ওঠে।`)
};

const zh_tw2_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個頁面由與你相關的一切構成——你監護的孩子、你執教的球隊、你追蹤的賽事。只有登入才能把它填滿。`)
};

const zh_hk2_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個頁面由與你相關的一切構成——你監護的孩子、你執教的球隊、你追蹤的賽事。只有登入才能把它填滿。`)
};

const ur_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ صفحہ اُنہی چیزوں سے بنتا ہے جن سے آپ جڑے ہیں — وہ بچے جن کے آپ سرپرست ہیں، وہ ٹیمیں جنہیں آپ تربیت دیتے ہیں، وہ ایونٹ جو آپ فالو کرتے ہیں۔ سائن اِن کرنے پر ہی یہ بھرتا ہے۔`)
};

const fa_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این صفحه از آنچه با شما مرتبط است ساخته می‌شود — کودکانی که سرپرست‌شان هستید، تیم‌هایی که تمرین می‌دهید، رویدادهایی که دنبال می‌کنید. تنها ورود آن را پر می‌کند.`)
};

const sw_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukurasa huu unaundwa na yale unayohusiana nayo — watoto unaowalea, timu unazozifunza, matukio unayoyafuatilia. Kuingia ndiko kunakoujaza.`)
};

const nl_profile_signed_out_why = /** @type {(inputs: Profile_Signed_Out_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze pagina ontstaat uit waar je mee te maken hebt — de kinderen van wie je voogd bent, de teams die je traint, de evenementen die je volgt. Pas inloggen vult haar.`)
};

/**
* | output |
* | --- |
* | "This page is built from what you are connected to — the children you are guardian to, the teams you coach, the events you follow. Signing in is what fills it." |
*
* @param {Profile_Signed_Out_WhyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const profile_signed_out_why = /** @type {((inputs?: Profile_Signed_Out_WhyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Signed_Out_WhyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_profile_signed_out_why(inputs)
	if (locale === "ja") return ja_profile_signed_out_why(inputs)
	if (locale === "zh") return zh_profile_signed_out_why(inputs)
	if (locale === "es") return es_profile_signed_out_why(inputs)
	if (locale === "pt") return pt_profile_signed_out_why(inputs)
	if (locale === "id") return id_profile_signed_out_why(inputs)
	if (locale === "fr") return fr_profile_signed_out_why(inputs)
	if (locale === "tl") return tl_profile_signed_out_why(inputs)
	if (locale === "vi") return vi_profile_signed_out_why(inputs)
	if (locale === "ko") return ko_profile_signed_out_why(inputs)
	if (locale === "de") return de_profile_signed_out_why(inputs)
	if (locale === "ru") return ru_profile_signed_out_why(inputs)
	if (locale === "tr") return tr_profile_signed_out_why(inputs)
	if (locale === "it") return it_profile_signed_out_why(inputs)
	if (locale === "pl") return pl_profile_signed_out_why(inputs)
	if (locale === "uk") return uk_profile_signed_out_why(inputs)
	if (locale === "hi") return hi_profile_signed_out_why(inputs)
	if (locale === "ar") return ar_profile_signed_out_why(inputs)
	if (locale === "ms") return ms_profile_signed_out_why(inputs)
	if (locale === "bn") return bn_profile_signed_out_why(inputs)
	if (locale === "zh-TW") return zh_tw2_profile_signed_out_why(inputs)
	if (locale === "zh-HK") return zh_hk2_profile_signed_out_why(inputs)
	if (locale === "ur") return ur_profile_signed_out_why(inputs)
	if (locale === "fa") return fa_profile_signed_out_why(inputs)
	if (locale === "sw") return sw_profile_signed_out_why(inputs)
	if (locale === "nl") return nl_profile_signed_out_why(inputs)
	return en_profile_signed_out_why(inputs)
});